export default __webpack_public_path__ + "static/media/alam2.ac8d2849.avif";